import React, { useRef, useState } from "react";
import { Button } from "@mui/material";
// import { uploadToCloudinary } from "../services/cloudinaryUpload";
import cameraIcons from "../assets/img/icons/add_camera_icon.png";
import { uploadToCloudinary } from "../features/shareMessage/Cloudanary";

export default function ImageUploadButton({
  imageSrc,
  setImageSrc,
  fileCb,
  multiple,
  useCloudinary = false,
}) {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file.size > 10 * 1024 * 1024) {
      // 10MB limit
      alert("File is too large! Please upload an image smaller than 10MB.");
      return;
    }

    if (file) {
      // Upload to Cloudinary
      const url = await uploadToCloudinary(file);
      if (url) {
        setImageSrc(url); // Save image URL
        if (fileCb) fileCb(url); // Callback to parent
      }
    }
  };

  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleButtonClick}
        sx={{ color: "#000", fontWeight: 500, fontSize: 14, width: 195 }}
      >
        <img
          src={cameraIcons}
          alt="icon"
          style={{ width: 22, height: 22, marginRight: 8 }}
        />
        Attach Image
      </Button>

      <input
        type="file"
        multiple={multiple}
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {imageSrc && (
        <div style={{ marginTop: "20px" }}>
          <img
            src={imageSrc}
            alt="Uploaded"
            style={{ maxWidth: "300px", height: "auto" }}
          />
        </div>
      )}
    </div>
  );
}
